class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      
      // Always fetch fresh data to ensure filter counts are accurate
      // Caching caused stale counts when revisiting filter combinations
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
        // Remove price-visually-hidden to show prices (already populated by Liquid)
        const priceWrappers = document.querySelectorAll('#ProductGridContainer .dynamic-price__wrapper.price-visually-hidden');
        priceWrappers.forEach(function(wrapper) {
          wrapper.classList.remove('price-visually-hidden');
        });
        
        // Enable submit buttons
        const submitButtons = document.querySelectorAll('#ProductGridContainer .submit-button[disabled]');
        submitButtons.forEach(function(btn) {
          btn.disabled = false;
        });
        
        // Hide filter options with 0 products
        FacetFiltersForm.hideZeroCountFilters();
        
        // Hide location filter badge after facets render
        if (typeof window.markLocationBadges === 'function') {
          window.markLocationBadges();
        }
        if (typeof window.interceptRemoveAll === 'function') {
          window.interceptRemoveAll();
        }
        
        if (typeof agileCart !== 'undefined') {
          agileCart.fetchCart();
        }
        
        // Scroll to top after filters applied
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    
    // Direct fix: Remove price-visually-hidden from all price wrappers after facets render
    const priceWrappers = document.querySelectorAll('#ProductGridContainer .dynamic-price__wrapper.price-visually-hidden');
    priceWrappers.forEach(function(wrapper) {
      wrapper.classList.remove('price-visually-hidden');
    });
    
    // Enable submit buttons
    const submitButtons = document.querySelectorAll('#ProductGridContainer .submit-button[disabled]');
    submitButtons.forEach(function(btn) {
      btn.disabled = false;
    });
    
    // Hide filter options with 0 products
    FacetFiltersForm.hideZeroCountFilters();
    
    // Hide location filter badge after facets render
    if (typeof window.markLocationBadges === 'function') {
      window.markLocationBadges();
    }
    if (typeof window.interceptRemoveAll === 'function') {
      window.interceptRemoveAll();
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    
    // Remove loading state from collection
    const collection = document.getElementById('ProductGridContainer').querySelector('.collection');
    if (collection) {
      collection.classList.remove('loading');
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    
    // Try ProductCountDesktop first (main collection grid), then ProductCount as fallback
    const parsedCount = parsedHTML.getElementById('ProductCountDesktop') || parsedHTML.getElementById('ProductCount');
    const count = parsedCount ? parsedCount.innerHTML : '';
    
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (count) {
      if (container) {
        container.innerHTML = count;
        container.classList.remove('loading');
      }
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    } else {
      // Fallback: count visible products in the grid
      const visibleProducts = parsedHTML.querySelectorAll('#product-grid .product-item, #product-grid .grid__item');
      if (visibleProducts.length > 0 && containerDesktop) {
        containerDesktop.textContent = visibleProducts.length + ' products';
        containerDesktop.classList.remove('loading');
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      } else {
        console.warn(`Filter element with data-index="${element.dataset.index}" not found in DOM`);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (!sourceElement || !targetElement) return;
      targetElement.innerHTML = sourceElement.innerHTML;
    });

    const mobileFacetForm = document.getElementById('FacetFiltersFormMobile');
    const menuDrawer = mobileFacetForm?.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static hideZeroCountFilters() {
    // Hide filter options that show (0) products to prevent misleading UI
    const filterLabels = document.querySelectorAll('.facets__label, .mobile-facets__label');
    
    filterLabels.forEach(function(label) {
      const text = label.textContent || '';
      // Match patterns like "(0)" or "(0 products)"
      const match = text.match(/\((\d+)(?:\s*product)?/i);
      
      if (match && parseInt(match[1], 10) === 0) {
        // Find the parent list item and hide it
        const listItem = label.closest('li');
        if (listItem) {
          listItem.style.display = 'none';
        }
      }
    });
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static getCurrentLocation() {
    return window.locationManager?.currentLocation ||
      localStorage.getItem('selectedLocation') ||
      localStorage.getItem('currentPickingStore') ||
      '76';
  }

  static isSpecialsCollectionPath(pathname = window.location.pathname) {
    const match = (pathname || '').match(/^\/collections\/([^\/]+)\/?$/);
    if (!match) return false;
    const handle = match[1];
    // Unified specials collections (incl. online-specials and grocery-specials) —
    // all keep special_locations in sync with the picking store.
    const specialsHandles = new Set([
      'online-specials',
      'grocery-specials',
      'fruit-and-veg-specials',
      'butcher-specials',
      'seafood-specials',
      'organic-specials',
      'fridge-specials',
      'snacks-specials',
      'drinks-specials',
      'pet-specials',
      'liquor-specials',
      'fruit-veg-box-specials',
      'meal-kit-specials',
      'fruit-specials',
      'vegies-specials',
      'cheese-specials',
      'bakery-specials'
    ]);
    return specialsHandles.has(handle);
  }

  static withLocationFilters(searchParams) {
    const params = typeof searchParams === 'string'
      ? new URLSearchParams(searchParams)
      : searchParams;
    const currentLocation = FacetFiltersForm.getCurrentLocation();
    params.set('filter.p.m.custom.available_locations', currentLocation);
    if (FacetFiltersForm.isSpecialsCollectionPath()) {
      params.set('filter.p.m.custom.special_locations', currentLocation);
    }
    return params.toString();
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    return FacetFiltersForm.withLocationFilters(searchParams);
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    url = FacetFiltersForm.withLocationFilters(url);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Hide filter options with 0 products on initial page load
document.addEventListener('DOMContentLoaded', function() {
  FacetFiltersForm.hideZeroCountFilters();
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const link = event.currentTarget || event.target.closest('a');
    if (!link || !link.href) return;
    
    FacetFiltersForm.toggleActiveFacets();
    
    // Extract URL parameters from the link href
    let url = link.href.indexOf('?') === -1
      ? ''
      : link.href.slice(link.href.indexOf('?') + 1);
    
    url = FacetFiltersForm.withLocationFilters(url);
    FacetFiltersForm.renderPage(url);
  }
}

customElements.define('facet-remove', FacetRemove);

